import { MotorsportsCalendarRowData } from '@sky-it-livedata/livedata-sports-design-system';

/**
 * Get season year by gpInfo Array
 * @param motorsportsCalendarPageData array of gpInfo
 * @returns season string
 */
export const getCalendarSeasonByGPCalendar = (motorsportsCalendarPageData: Array<MotorsportsCalendarRowData>): string =>
  motorsportsCalendarPageData.length > 0
    ? new Date(motorsportsCalendarPageData[0]?.dateStart!).getFullYear().toString() ?? ''
    : '';
